export const ticketCategoriesRoutes = {
  list: "",
  create: "new",
  edit: ":id/edit",
} as const;
